import PropTypes from 'prop-types';
import React from 'react';
import Leaflet from 'leaflet';

import usePopUp from './usePopUp';

const LabelPopup = ({coords, label, className = '', isAutoPan}) => {
    const popUp = new Leaflet.Popup({
        className,
        closeButton: false,
        autoClose: false,
        closeOnEscapeKey: false,
        autoPan: isAutoPan
    })
        .setLatLng(coords)
        .setContent(label);


    usePopUp(popUp, true);
    return undefined;
};

LabelPopup.propTypes = {
    coords: PropTypes.objectOf({
        lat: PropTypes.number,
        lng: PropTypes.number,
    }).isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    isAutoPan: PropTypes.bool
};

export default React.memo(LabelPopup);



// WEBPACK FOOTER //
// ./src/components/openMap/LabelPopup.js